//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfButton from "../../atoms/SfButton/SfButton.vue";
import MoominLink from "~/themes/fiskarsMoominDefault/components/components/atoms/MoominLink/MoominLink.vue";
export default {
  name: "SfBanner",
  components: {
    SfButton,
    MoominLink,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    buttonText: {
      type: String,
      default: "",
    },
    link: {
      type: String,
      default: "",
    },
    buttonTextSecondary: {
      type: String,
      default: "",
    },
    linkSecondary: {
      type: String,
      default: null,
    },
    background: {
      type: String,
      default: "var(--c-secondary)",
    },
    image: {
      type: Object
    },
    imageTag: {
      type: String,
      default: null,
    },
    nuxtImgConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    wrapper() {
      return this.link ? "MoominLink" : "SfButton";
    },
  },
};
